import React from 'react';
import PropTypes from 'prop-types';

const LoadingDots = ({ dark }) => (
  <span className={`loading-dots ${dark ? 'loading-dots--dark' : ''}`}>
    <span className="loading-dot" />
    <span className="loading-dot" />
    <span className="loading-dot" />
  </span>
);

LoadingDots.propTypes = {
  dark: PropTypes.bool,
};

LoadingDots.defaultProps = {
  dark: false,
};

export default LoadingDots;
